module.exports = "<div dynamic=build.getContent()></div> ";